import { Controller } from "@hotwired/stimulus";

/**
 * The student lists form (GO4SDOC): shows only the settings the chosen
 * template, format and scope use.
 *
 * - [data-student-list-form-target="templated"] with data-templates="a b c"
 *   is shown when the template is one of them;
 * - [data-student-list-form-target="formatted"] with data-formats="pdf" is
 *   shown for those formats;
 * - [data-student-list-form-target="scoped"] with data-scope="classrooms" is
 *   the checkbox list of that scope, shown when it is the chosen scope.
 * Hidden settings are disabled, so they are not sent.
 */
export default class extends Controller {
  static targets = ["template", "format", "scope", "templated", "formatted", "scoped", "orientation"];
  static values = { landscape: String };

  connect() {
    this.refresh();
  }

  // A wide template (list with parents, weekly attendance) is printed in
  // landscape by default; the orientation can still be changed after.
  templateChanged() {
    const wide = this.landscapeValue.split(" ").includes(this.templateTarget.value);
    this.orientationTargets.forEach((radio) => {
      radio.checked = radio.value === (wide ? "landscape" : "portrait");
    });
    this.refresh();
  }

  refresh() {
    const template = this.hasTemplateTarget ? this.templateTarget.value : "";
    const format = this.checkedValue(this.formatTargets);
    const scope = this.hasScopeTarget ? this.scopeTarget.value : "";

    this.templatedTargets.forEach((element) => {
      this.toggle(element, (element.dataset.templates || "").split(" ").includes(template));
    });
    this.formattedTargets.forEach((element) => {
      this.toggle(element, (element.dataset.formats || "").split(" ").includes(format));
    });
    this.scopedTargets.forEach((element) => {
      this.toggle(element, element.dataset.scope === scope);
    });
  }

  checkedValue(inputs) {
    const checked = inputs.find((input) => input.checked);
    return checked ? checked.value : (inputs[0] && inputs[0].value) || "";
  }

  toggle(element, visible) {
    element.hidden = !visible;
    element.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !visible;
    });
  }
}
